import { unref as _unref, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0
};
import { ref, reactive, onMounted } from 'vue';
import { XTableLayout } from '@/components';
import { api } from '@/server';
import { SearchOutlined } from '@ant-design/icons-vue';

import { fetchApi } from '/Users/ytx/ytx/projects/jxpj/web/jxpj-client/src/server/auto-import.js';
export default {
  __name: 'userSelect',
  emits: ['select', 'row-click', 'row-dblclick'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const {
      loading,
      error,
      runAsync: getUserPage
    } = fetchApi(api.user.getPage);
    const emit = __emit;
    const columns = ref([{
      title: '序号',
      dataIndex: 'index',
      width: 70,
      fixed: 'left'
    }, {
      title: '账号',
      dataIndex: 'username',
      width: 120,
      resizeable: true,
      sort: true
    }, {
      title: '昵称',
      dataIndex: 'nickname',
      sort: true
    }, {
      title: '手机号',
      dataIndex: 'mobile',
      width: 160,
      resizeable: true,
      sort: true
    }, {
      title: '邮箱',
      dataIndex: 'email',
      width: 220,
      resizeable: true,
      sort: true
    }, {
      title: '操作',
      dataIndex: 'action',
      width: 120
    }]);
    const queryParams = reactive({
      search: '',
      pi: 1,
      ps: 50,
      order: []
    });
    const state = reactive({
      total: 0,
      pc: 0,
      rows: []
    });
    const selectRow = ref();
    const loadData = async () => {
      const {
        error,
        rows = [],
        total = 0,
        pc = 0,
        pi = 1,
        ps = 50
      } = await getUserPage({
        ...queryParams
      });
      if (error) return;
      selectRow.value = null;
      Object.assign(state, {
        total,
        pc,
        rows
      });
      Object.assign(queryParams, {
        pi,
        ps
      });
    };
    const doSearch = async () => {
      load();
    };
    const refresh = () => {
      loadData();
    };
    const load = () => {
      queryParams.pi = 1;
      loadData();
    };
    onMounted(() => {
      loadData();
    });
    const handleTableChange = ({
      pageIndex,
      pageSize,
      order
    }) => {
      Object.assign(queryParams, {
        pi: pageIndex,
        ps: pageSize,
        order: order || []
      });
      refresh();
    };
    const handleTableClick = row => {
      selectRow.value = row;
      emit('row-click', row);
    };
    const handleTableDblClick = row => {
      selectRow.value = row;
      emit('row-dblclick', row);
    };
    const handleSelect = row => {
      emit('select', row);
    };
    __expose({
      load,
      refresh
    });
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_button = _resolveComponent("a-button");
      return _openBlock(), _createBlock(_unref(XTableLayout), {
        loading: _unref(loading),
        error: _unref(error),
        columns: columns.value,
        total: state.total,
        "page-index": queryParams.pi,
        "page-size": queryParams.ps,
        rows: state.rows,
        pagination: true,
        onTableChange: handleTableChange,
        onRowClick: handleTableClick,
        onRowDblclick: handleTableDblClick
      }, {
        searchbar: _withCtx(() => [_createVNode(_component_a_input, {
          value: queryParams.search,
          "onUpdate:value": _cache[0] || (_cache[0] = $event => queryParams.search = $event),
          placeholder: "搜索账号/昵称/手机号",
          onKeyup: _withKeys(doSearch, ["enter", "native"])
        }, null, 8, ["value"]), _createVNode(_component_a_button, {
          onClick: doSearch
        }, {
          icon: _withCtx(() => [_createVNode(_unref(SearchOutlined))]),
          default: _withCtx(() => [_cache[1] || (_cache[1] = _createTextVNode(" 搜索 ", -1))]),
          _: 1
        })]),
        bodyCell: _withCtx(({
          record,
          column,
          index
        }) => [!!column && column.dataIndex === 'index' ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(index + 1), 1)) : !!column && column.dataIndex === 'action' ? (_openBlock(), _createBlock(_component_a_button, {
          key: 1,
          type: "link",
          onClick: () => handleSelect(record)
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("选择", -1)]))]),
          _: 1
        }, 8, ["onClick"])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["loading", "error", "columns", "total", "page-index", "page-size", "rows"]);
    };
  }
};